import { EtablissementDto } from '@common/services';
import { DsfrModal, getModalById } from '@common/ui';
import { Address, Place } from '@common/ui/etablissement';
import { DateUtils } from '@common/utils';
import { sleep } from '@common/utils/promise';
import React, { ReactNode } from 'react';

const editEtablissementInfoModal = getModalById('etablissement-edit-info-modal');

export const EtablissementInfoModal = ({ dsfrModal, etablissement }: EtablissementInfoModalProps) => {
  const handleEditInfo = async () => {
    dsfrModal.close();
    await sleep(300);
    editEtablissementInfoModal.open();
  };

  const place: Place = {
    adresse: etablissement.adresse,
    complementAdresse: etablissement.complementAdresse,
    codePostal: etablissement.codePostal,
    ville: etablissement.ville,
  };

  const contents: Content[] = [
    { title: 'SIRET', value: etablissement.siret },
    { title: 'NDA', value: etablissement.nda },
    { title: 'UAI', value: etablissement.uai },
    { title: 'Effectif d\'apprentis', value: etablissement.effectifApprenti },
    { title: 'Adresse', value: <Address place={place} /> },
  ];

  return (
    <dsfrModal.Component title={''}
                         size="large"
                         topAnchor={false}
                         buttons={[
                           {
                             children: 'MODIFIER',
                             doClosesModal: false,
                             priority: 'tertiary',
                             onClick: () => handleEditInfo(),
                           },
                           {
                             children: 'RETOUR',
                             doClosesModal: true,
                             priority: 'primary',
                           },
                         ]}>

      <div className={'flex flex-col p-6'}>

        <div className={'flex flex-col gap-6'}>

          <h4 className={'m-0!'}>CFA {etablissement.denominationUsuelle}</h4>

          <span
            className={'text-sm text-[#484D7A] mb-6'}>Ajouté le {DateUtils.formatDdMmYyyy(etablissement.dateCreation)}</span>
        </div>

        <div className={'mt-4 grid grid-cols-2 gap-4'}>
          {contents.map(({ title, value }, index) => (
            <div key={`${index}-${title}`} className={'flex flex-col gap-2'}>
              <span className={'color-primary'}>{title}</span>
              <span>{value}</span>
            </div>
          ))}
        </div>
      </div>
    </dsfrModal.Component>
  );
};

interface EtablissementInfoModalProps {
  dsfrModal: DsfrModal;
  etablissement: EtablissementDto;
}

interface Content {
  title: string;
  value: ReactNode;
}

